import AginovaMonitorsStore from '@/Core.Service.Domain/Monitors/Aginova/Store';
import EgaugeAutoRegisterStore from '@/Core.Service.Domain/Monitors/Egauges/Store/index.ts';

export default {
  namespaced: true,
  modules: {
    AginovaMonitorsStore,
    EgaugeAutoRegisterStore,
  },
};
